<script lang="ts" setup>
definePageMeta({
  authType: 'public',
  validate(to) {
    const type = to.params.legal
    if (typeof type !== 'string') return false

    const landingPages = [
      'agb',
      'datenschutz',
      'impressum',
      'nutzungsbedingungen',
    ] as const satisfies LandingPageType[]

    return landingPages.includes(type as Exclude<LandingPageType, 'homepage'>)
  },
  layoutProps: {
    solidHeader: true,
  },
})

const type = useRoute().params.legal as Exclude<LandingPageType, 'homepage'>

const { data: page, suspense } = useLandingPageByType(type)
onServerPrefetch(async () => {
  await suspense()
})
useSeoMeta({
  title: computed(() => page.value?.title ?? ''),
})

function openCookieBanner() {
  window.falconCookie?.open()
}
</script>

<template>
  <div v-if="page" class="mt-20">
    <AlPadding v-if="page.type === 'datenschutz'" class="mb-8">
      <button class="bg-gray-200 px-4 py-2" @click="() => openCookieBanner()">
        Cookie-Banner öffnen
      </button>
    </AlPadding>

    <AlCmsPageSection
      v-for="section of page.cms_page_section"
      :key="section.id"
      :section="section"
    />
  </div>
  <div v-else />
</template>
